

// import { sendMessage } from "../../../api/gramjs/methods";

import { ApiChat, ApiMessage } from "../../../api/types";
import { getActions } from "../../../global";

import React, { FC, memo, useEffect, useRef, useSignal, useState } from "../../../lib/teact/teact";

import Avatar from "../../common/Avatar";
import Button from "../../ui/Button";
import ConfirmDialog from "../../ui/ConfirmDialog";
import DropdownMenu from "../../ui/DropdownMenu";

import MenuItem from "../../ui/MenuItem";
import { DBManager } from "../db/dbManager";
import store from "../store";
import { LuuTrongTinNhan, SendTeleMessage } from "../tdlib/tdlib";
import LotCheckBox from "../ui/lotCheckBox";

import { getDateTimeString, secondsToDate, secondsToDateString } from "../utils/DateTimeUtils";
import './teleMessgeList.scss'
import { onNewMessageNotiProcessed } from "../redux/tdlibSlice";
import { debounce, GetUserFullInfo } from "../utils/common";
import { DEBUG } from "../../../config";
import { globalDexieDb } from "../db/DexiedbLib";
import { parseMessageInput } from "../telehook/telehookUtils";
import { enumDauVaoTinNhan } from "../commontypes";
import { gotdapi } from "../restapi/gotd";
import { syncTeleMessages } from "../db/gotd";

export type TeleChatDisplayType = 'Chat' | 'ChatDetails'
type SourceToGet = "messages" | "deletedMessages" | "editedMessages"
type OwnProps = {
    chat: ApiChat
    onBack: () => void;
    onTransMessagesFromSelectedToParse: (messages: ApiMessage[]) => void;
    onShowSnackBar: (text: string) => void;
}

const TeleMessageList: FC<OwnProps> = ({
    chat,
    onBack,
    onTransMessagesFromSelectedToParse,
    onShowSnackBar,
}) => {
    const [syncRecords, setSyncRecords] = useState<any[]>([])
    const [getHtml, setHtml] = useSignal('');
    const inputRef = useRef<any>()
    const lastItemRef = useRef<any>()
    const userInfo = GetUserFullInfo();
    const {
        sendMessage,
        clearDraft,
        showDialog,
        forwardMessages,
        openPollModal,
        closePollModal,
        loadScheduledHistory,
        openChat,
        addRecentEmoji,
        sendInlineBotResult,
        loadSendAs,
        resetOpenChatWithDraft,
        callAttachBot,
        addRecentCustomEmoji,
        showNotification,
        showAllowedMessageTypesNotification,
        openStoryReactionPicker,
        closeReactionPicker,
        sendStoryReaction,
    } = getActions();
    const workDate = store.getState().global.workDate
    const [state, setState] = useState({
        messages: [] as any[],
        sourToGet: "messages" as SourceToGet,
        selectedMessageIds: [] as number[],
        rangeAnchorMessageIds: [] as number[], // lưu 2 mốc manual gần nhất: n, k
        inSelectMessageMode: false,
        danhDauBoDialogOpen: false,
        xoaTinDialogOpen: false,
        reloadFlip: false,

    })
    const notiMesssages = store.getState().wsSlice.messages;
    useEffect(() => {
        if (state.sourToGet == "messages") {
            if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegram) { // tin tele trực tiếp thì đọc từ bảng  telegramMessages
                globalDexieDb.telegramMessage.where('[ownerId+chatId]').equals([userInfo.username, Number(chat.id)]).toArray().then(result => {



                    const sorted = result.sort((a, b) => {
                        if (b.date > a.date)
                            return -1;
                        if (b.date < a.date)
                            return 1;
                        return 0;
                    })
                    // convert to ApiMessage
                    const apiMsgs = sorted.map(msg => {
                        const apiMsg: ApiMessage = {
                            id: msg.messageId,
                            chatId: msg.chatId.toString(),
                            date: msg.date,
                            isOutgoing: msg.isOutgoing,
                            content: { text: { text: msg.text } }
                        }
                        return apiMsg
                    })
                    setState(prev => ({ ...prev, messages: apiMsgs, }))
                })
            } else {
                globalDexieDb.messages.where('chatId').equals(chat.id).toArray().then(result => {
                    const tmp: any[] = []

                    for (let msg of result) {
                        if (msg.content.text && msg.content.text.text)
                            tmp.push(msg)
                    }
                    const sorted = tmp.sort((a, b) => {
                        if (b.date > a.date)
                            return -1;
                        if (b.date < a.date)
                            return 1;
                        return 0;
                    })
                    setState(prev => ({ ...prev, messages: sorted, }))
                })
            }
        } else if (state.sourToGet == "editedMessages") {
            globalDexieDb.editedMessages.where('chatId').equals(chat.id).toArray().then(result => {
                const tmp: any[] = []

                for (let msg of result) {
                    if (msg.content.text && msg.content.text.text)
                        tmp.push(msg)
                }
                const sorted = tmp.sort((a, b) => {
                    if (b.date > a.date)
                        return -1;
                    if (b.date < a.date)
                        return 1;
                    return 0;
                })
                setState(prev => ({ ...prev, messages: sorted, selectedMessageIds: [] }))
            })
        } else if (state.sourToGet == "deletedMessages") {
            globalDexieDb.deletedMessages.where('chatId').equals(chat.id).toArray().then(result => {
                const tmp: any[] = []

                for (let msg of result) {
                    if (msg.content.text && msg.content.text.text)
                        tmp.push(msg)
                }
                const sorted = tmp.sort((a, b) => {
                    if (b.date > a.date)
                        return -1;
                    if (b.date < a.date)
                        return 1;
                    return 0;
                })
                setState(prev => ({ ...prev, messages: sorted, selectedMessageIds: [] }))
            })
        }




    }, [workDate, state.sourToGet, state.reloadFlip, notiMesssages, syncRecords])
    useEffect(() => {
        setState(prev => ({ ...prev, selectedMessageIds: [], rangeAnchorMessageIds: [] }))
    }, [state.sourToGet])
    function getNextRangeAnchors(prevAnchors: number[], messageId: number): number[] {
        const anchorsWithoutCurrent = prevAnchors.filter(id => id != messageId);
        const next = [...anchorsWithoutCurrent, messageId];
        return next.length > 2 ? next.slice(next.length - 2) : next;
    }
    function handleSelectMessage(id: number) {
        setState(prev => {
            let tmp = [...prev.selectedMessageIds];
            if (!tmp.includes(id)) {
                tmp.push(id);
            } else {
                tmp = tmp.filter(msgId => msgId != id);
            }
            const nextAnchors = getNextRangeAnchors(prev.rangeAnchorMessageIds, id);
            return {
                ...prev,
                inSelectMessageMode: tmp.length == 0 ? false : prev.inSelectMessageMode,
                selectedMessageIds: tmp,
                rangeAnchorMessageIds: nextAnchors,
            };
        })
    }
    function handleTransMessagesFromSelectedToParse() {
        const messages: ApiMessage[] = []
        state.messages.forEach(msg => {
            if (state.selectedMessageIds.includes(msg.id))
                messages.push(msg)
        })
        onTransMessagesFromSelectedToParse(messages)
    }
    function handleSelectMessagesInRange() {
        if (state.rangeAnchorMessageIds.length < 2) {
            onShowSnackBar("Cần chọn manual 2 mốc n và k trước")
            return;
        }
        const nIndex = state.messages.findIndex(msg => msg.id == state.rangeAnchorMessageIds[0]);
        const kIndex = state.messages.findIndex(msg => msg.id == state.rangeAnchorMessageIds[1]);
        if (nIndex < 0 || kIndex < 0) {
            onShowSnackBar("Không tìm thấy mốc n hoặc k trong danh sách hiện tại")
            return;
        }
        const n = Math.min(nIndex, kIndex);
        const k = Math.max(nIndex, kIndex);
        if (Math.abs(k - n) <= 1) {
            onShowSnackBar("Hai mốc chọn phải không liền kề")
            return;
        }
        const selectedSet = new Set<number>(state.selectedMessageIds);
        for (let i = n; i <= k; i++) {
            selectedSet.add(state.messages[i].id);
        }
        setState(prev => ({ ...prev, selectedMessageIds: Array.from(selectedSet) }))
    }
    function handleUnselectMessagesInRange() {
        if (state.rangeAnchorMessageIds.length < 2) {
            onShowSnackBar("Cần chọn manual 2 mốc n và k trước")
            return;
        }
        const nIndex = state.messages.findIndex(msg => msg.id == state.rangeAnchorMessageIds[0]);
        const kIndex = state.messages.findIndex(msg => msg.id == state.rangeAnchorMessageIds[1]);
        if (nIndex < 0 || kIndex < 0) {
            onShowSnackBar("Không tìm thấy mốc n hoặc k trong danh sách hiện tại")
            return;
        }
        const n = Math.min(nIndex, kIndex);
        const k = Math.max(nIndex, kIndex);
        if (Math.abs(k - n) <= 1) {
            onShowSnackBar("Hai mốc chọn phải không liền kề")
            return;
        }
        const idsInRange = new Set<number>();
        for (let i = n; i <= k; i++) {
            idsInRange.add(state.messages[i].id);
        }
        const remainedIds = state.selectedMessageIds.filter((id) => !idsInRange.has(id));
        setState(prev => ({ ...prev, selectedMessageIds: remainedIds }))
    }
    function getSelectedMessages(): ApiMessage[] {
        const messages: ApiMessage[] = []
        state.messages.forEach(msg => {
            if (state.selectedMessageIds.includes(msg.id))
                messages.push(msg)
        })
        return messages
    }
    const DialogDanhDauBo = (
        <ConfirmDialog
            title="Bỏ các tin đã chọn"
            text={`Thao tác này sẽ đánh dấu các tin đã chọn không được nạp lên khi đọc tin phân tích, đồng thời xoá 
             dữ liệu đã phân tích của nó. Tin nhắn gốc không bị xoá.`}
            confirmLabel="Loại bỏ"
            isOpen={state.danhDauBoDialogOpen}
            confirmHandler={() => LuuTrongTinNhan(getSelectedMessages()).then(result => {
                setState(prev => ({ ...prev, danhDauBoDialogOpen: false }))
                onShowSnackBar(result.responseText)

            })}
            onClose={() => setState(prev => ({ ...prev, danhDauBoDialogOpen: false }))}
        >

        </ConfirmDialog>
    )
    const DialogXoaTin = (
        <ConfirmDialog
            title="Xoá các tin đã chọn"
            text={`Thao tác này xoá toàn bộ các tin đã chọn và dữ liệu đã phân tích của nó.`}
            confirmLabel="Xoá"
            isOpen={state.xoaTinDialogOpen}
            confirmHandler={() => LuuTrongTinNhan(getSelectedMessages(), true).then(result => {
                setState(prev => ({ ...prev, selectedMessageIds: [], xoaTinDialogOpen: false, reloadFlip: !prev.reloadFlip }))
                onShowSnackBar(result.responseText)

            })}
            onClose={() => setState(prev => ({ ...prev, xoaTinDialogOpen: false }))}
        >

        </ConfirmDialog>
    )
    function addNewMessage(newMessage: any) {
        // const tmp = state.messages;
        // tmp.push(newMessage)
        // setState(prev => ({ ...prev, messages: tmp }))
        setState(prev => ({ ...prev, reloadFlip: !prev.reloadFlip }))
    }
    const debounceSet = debounce(() => {
        const noti = store.getState().tdlibSlice
        if (noti.newMessagesArived.length > 0) {
            const newMessage: any = noti.newMessagesArived[0];

            store.dispatch(onNewMessageNotiProcessed({}))
            //console.log('new message:', newMessage)
            //console.log('noti.newMessagesArived.length :', noti.newMessagesArived.length)
            if (newMessage.chatId == chat.id) {
                addNewMessage(newMessage)
            }
        }
    }, 10)
    const debounceScroll = debounce(() => {
        if (lastItemRef.current)
            lastItemRef.current.scrollIntoView()
    }, 100)
    useEffect(() => {
        const unsub = store.subscribe(() => {
            debounceSet()
        })
        return unsub;
    }, [])
    useEffect(() => {
        debounceScroll()
    }, [state.messages])
    useEffect(() => {
        const sync = async () => {
            let records = await syncTeleMessages({ chat_id: Number(chat.id) })
            setSyncRecords(records);
        }
        sync();
    }, [chat])
    return (
        <div className="message-list-main">
            {DialogDanhDauBo}
            {DialogXoaTin}
            <div className="toolbar">


                <div className=" common-container-row" >
                    <div className="common-container-row left-panel">
                        <Button
                            round
                            size="smaller"
                            color="translucent"
                            onClick={() => {
                                onBack()
                            }}
                        >
                            <i className="icon icon-arrow-left" />
                        </Button>
                        <Avatar size="medium" text={chat.title} />
                        <div>{chat.title
                            + (state.selectedMessageIds.length > 0
                                ? ` (đã chọn ${state.selectedMessageIds.length}/${state.messages.length})`
                                : "")}</div>
                    </div>
                    <div className="common-container-row right-panel">
                        <DropdownMenu positionX="right">
                            {
                                state.selectedMessageIds.length > 0 &&
                                <>
                                    <MenuItem
                                        onClick={() => handleTransMessagesFromSelectedToParse()}
                                    >
                                        Phân tích tin đã chọn
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => setState(prev => ({ ...prev, danhDauBoDialogOpen: true }))}
                                    >
                                        Đánh dấu bỏ các tin đã chọn
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => setState(prev => ({ ...prev, xoaTinDialogOpen: true }))}
                                    >
                                        Xoá các tin đã chọn
                                    </MenuItem>
                                </>
                            }
                            <MenuItem onClick={() => {
                                setState(prev => ({ ...prev, sourToGet: "messages" }))
                            }}
                                icon={state.sourToGet == "messages" ? "icon icon-check" : ""}
                            >Tin nhắn thông thường</MenuItem>
                            <MenuItem onClick={() => {
                                setState(prev => ({ ...prev, sourToGet: "editedMessages" }))
                            }}
                                icon={state.sourToGet == "editedMessages" ? "icon icon-check" : ""}
                            >Tin bị sửa</MenuItem>
                            <MenuItem
                                onClick={() => {
                                    setState(prev => ({ ...prev, sourToGet: "deletedMessages" }))
                                }}
                                icon={state.sourToGet == "deletedMessages" ? "icon icon-check" : ""}
                            >Tin bị xoá</MenuItem>
                            <MenuItem
                                onClick={() => {
                                    const newSelectMode = !state.inSelectMessageMode
                                    setState(prev => ({ ...prev, inSelectMessageMode: newSelectMode }))
                                    if (!newSelectMode) {
                                        setState(prev => ({ ...prev, selectedMessageIds: [], rangeAnchorMessageIds: [] }))
                                    }
                                }}

                            >Chọn tin nhắn</MenuItem>
                            {
                                state.inSelectMessageMode &&
                                <MenuItem
                                    onClick={handleSelectMessagesInRange}
                                >
                                    Chọn trong khoảng
                                </MenuItem>
                            }
                            {
                                state.inSelectMessageMode &&
                                <MenuItem
                                    onClick={handleUnselectMessagesInRange}
                                >
                                    Bỏ chọn trong khoảng
                                </MenuItem>
                            }
                            {
                                state.inSelectMessageMode &&
                                <MenuItem
                                    icon={state.inSelectMessageMode ? "icon icon-replace" : "icon icon-replace"}
                                    onClick={() => {
                                        const tmp = state.selectedMessageIds
                                        const reversed: number[] = []
                                        for (let i = state.messages.length - 1; i >= 0; i--) {
                                            const msg = state.messages[i]
                                            if (!tmp.includes(msg.id)) {
                                                reversed.push(msg.id)
                                            }
                                        }
                                        setState(prev => ({ ...prev, selectedMessageIds: reversed }))
                                    }}
                                >
                                    Đảo chọn tin nhắn
                                </MenuItem>
                            }
                        </DropdownMenu>
                    </div>
                </div>
            </div>
            <div className="message-list-container">
                {

                    state.messages.map((msg, index) => {
                        const date = secondsToDate(msg.date)

                        return (
                            <div className="list-item"
                                onClick={() => {
                                    console.log("message clicked")
                                    if (state.inSelectMessageMode) {
                                        handleSelectMessage(msg.id)

                                    }
                                }}
                                onContextMenu={(e) => {
                                    //console.log("context menu called")
                                    if (!state.inSelectMessageMode) {
                                        setState(prev => ({ ...prev, inSelectMessageMode: true }))
                                        e.preventDefault()
                                    }
                                }}
                                ref={index == (state.messages.length - 1) ? lastItemRef : undefined}
                            >
                                <div className="tele-message-card">
                                    <div className={msg.isOutgoing ? "body-container outbox" : "body-container"}>
                                        <div style="width:90%">
                                            <div key={msg.id} id={"msg" + msg.id}
                                                className={msg.isOutgoing ? "tele-message-body-outbox" : "tele-message-body-inbox"}>
                                                {msg.content.text ? msg.content.text.text : ""}
                                            </div>

                                            <div className="message-date"> {DEBUG && <> {msg.id}</>} {getDateTimeString(date)}</div>
                                            <div style="height:5px"></div>
                                            {/* {DEBUG && <div> {msg.id}</div>}  */}
                                        </div>
                                    </div>
                                </div>
                                {
                                    state.inSelectMessageMode &&
                                    <div className="checkbox">
                                        <LotCheckBox checked={state.selectedMessageIds.includes(msg.id)}
                                        ></LotCheckBox>
                                    </div>
                                }
                            </div>
                        )
                    })
                }

            </div>
            <div className="message-input-container" >

                <div ref={inputRef} className="message-input" contentEditable="true"
                    onChange={(e) => {
                        let { innerHTML, textContent } = e.currentTarget;
                        //setState((prev: any) => ({ ...prev, textToSend: textContent }))
                        setHtml(innerHTML)
                    }}
                ></div>
                <div className="send-button">
                    <Button
                        round
                        size="tiny"
                        onClick={() => {
                            const { text, } = parseMessageInput(getHtml());

                            if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegram) {
                                const peer = chat.id
                                gotdapi.sendMessage(peer, text)
                                console.log('send via gateway:', peer, text)
                            } else {

                                if (text.trim() != "") {
                                    console.log('send via direct weblogin:', chat.id, text)
                                    SendTeleMessage(text, chat.id, sendMessage)
                                }
                            }


                            inputRef.current.innerHTML = ""
                            setHtml("")
                        }}
                    >
                        <i className="icon icon-send"></i>
                    </Button>
                </div>
            </div>
        </div >
    )
}


export default memo(TeleMessageList)